const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['薪資報表', 'Salary report', '薪资报表'],
				children: {
					ZZ_SYUGUANG_PB00101: {
						name: ['薪資明細表表頭設定', 'Salary statement header setup', '薪资明细表表头设置'],
						url: '/zz_common_pb10020',
						hint: [],
						ZZ_SYUGUANG_PB00101: { name: ['薪資明細表表頭設定', 'Salary statement header setup', '薪资明细表表头设置'] },
					},
					ZZ_SYUGUANG_PB00102: {
						name: ['薪資報表', 'Salary report', '薪资报表'],
						url: '/zz_common_pb10021',
						hint: [],
						ZZ_SYUGUANG_PB00102: { name: ['薪資報表', 'Salary report', '薪资报表'] }, 
					},		
				},
			},
			ZZ2: {
				name: ['年薪(佳醫)', '年薪(佳醫)', '年薪(佳醫)'],
				children: {		
					ZZ_EXCELSIOR_PB00101: {
						name: ['(客製)年薪調整維護', '(客製)年薪調整維護', '(客製)年薪調整維護'],
						url: '/zz_excelsior_pb00101',
						hint: [],
					},			
				},
			},
			ZZ3: {
				name: ['特休假代金(佳醫)', 'Paid Special Leave(佳醫)', '带薪特别假期(佳医)'],
				children: {
					ZZ_EXCELSIOR_SPECIALPAYMENT_REPORT: {
						name: ['(客製)特休假代金預估報表', '(Customized) Paid Special Leave Estimation Report', '(定制)带薪特别假期估算报表'],
						url: '/zz_excelsior_specialpayment_report',
						hint: [],
					},
				},
			},
			ZZ4: {
				name: [`傳票(佳醫)`, `Accountting(佳醫)`, `传票(佳醫)`],
				children: {
					ZZ_EXCELSIOR_PB10030: {
							name: ['(客製)傳票設定', '(客製)Accountting Settings', '(客製)传票设定'],
							url: '/zz_excelsior_pb10030',
							hint: [],
					},
					ZZ_EXCELSIOR_PB10031: {
						name: ['(客製)傳票匯出', '(客製)Accountting Export', '(客製)传票汇出'],
						url: '/zz_excelsior_pb10031',
						hint: [],
					},
				},
			},
			ZZ5: {
				name: ['團保(佳醫)', '團保(佳醫)', '團保(佳醫)'],
				children: {
					ZZ_EXCELSIOR_PB10040: {
						name: ['(客製)團體保險參數設定', '(客製)團體保險參數設定', '(客製)團體保險參數設定'],
						url: '/zz_excelsior_pb10040',
						hint: [],
					},
					ZZ_EXCELSIOR_PB10041: {
						name: ['(客製)團體保險資料', '(客製)團體保險資料', '(客製)團體保險資料'],
						url: '/zz_excelsior_pb10041',
						hint: [],
					},
					ZZ_EXCELSIOR_PB10042: {
						name: ['(客製)團保試算作業', '(客製)團保試算作業', '(客製)團保試算作業'],
						url: '/zz_excelsior_pb10042',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};